import React from 'react';
import './404PageNotFound.scss';
import SEOUpdater from '../../utils/hoc/SEOUpdater';
import PagesHeroSection from '../../components/pagesHeroSection';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import Structured404 from '../../utils/structured404/structured404';
import { getCurrentLang } from '../../utils/withLang';

const PageNotFound = () => {
  const { t } = useTranslation('pageNotFound');
  const location = useLocation();

  const currentLang = getCurrentLang(location.pathname) || 'en';

  return (
    <div className="not-found-page">
      <SEOUpdater page="pageNotFound" />
      <Structured404 />

      <PagesHeroSection page={t('heroTitle')} />

      <div className="not-found-page-content">
        <p style={{ fontSize: '20px', color: '#666' }}>{t('message')}</p>

        <Link
          to={`/${currentLang}`}
          aria-label={t('backToHome', { defaultValue: 'Back to home' })}
          style={{ fontSize: '16px', color: '#007bff', textDecoration: 'none' }}
        >
          {t('backToHome')}
        </Link>
      </div>
    </div>
  );
};

export default PageNotFound;
